import React from "react";
import { SwipeableDrawer, Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./MessageDrawer.css";
import {LazyLoadImage} from "react-lazy-load-image-component";
import CabanaLogo from '../media/images/Cabana.svg';
interface MessageDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    modalProduct: any | null;
    orders: any[] | null
}

const MessageDrawer: React.FC<MessageDrawerProps> = ({
                                                         isOpen,
                                                         onClose,
                                                         modalProduct,
                                                         orders
                                                     }) => {
    const isMobile = useMediaQuery("(max-width:992px)");
    const anchorPosition = isMobile ? "bottom" : "right";

    if (!modalProduct || orders === null || orders.length === 0) return null;
    return (
        <SwipeableDrawer
            anchor={anchorPosition}
            open={isOpen}
            onClose={onClose}
            onOpen={() => {}}
        >
            <Box
                className="message-drawer"
                sx={{
                    width: isMobile ? "100vw" : 727
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", right: 10, top: 10, color: "black" }}
                >
                    <CloseIcon />
                </IconButton>

                <Typography className={'message-drawer-title'}>
                    Gift Message
                </Typography>

                <Box className={'container-box-images'}>
                    <Box className={'message-drawer-box-image'}>
                        <Box className={'img-container'}>
                            <LazyLoadImage
                                src={modalProduct.image_url}
                                alt="Product"
                            />
                        </Box>
                        <Box className={'box-text'}>
                            <Typography className={'gift-title'}>
                                Your gift:
                            </Typography>
                            <Typography className={'gift-name'}>
                                {modalProduct.title}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box className={'message-drawer-container-messages'}>

                    {orders.map((order: any) => {
                        if('products' in order && order.products.length > 0){
                            for(const product of order.products){
                                if(product.product_order_wishlist_x_product_id === modalProduct.wishlist_x_product_id){
                                    return (
                                        <Box className={'message-drawer-box-message'} key={`message-drawer-${order.id}`}>
                                            <Box className={'message-drawer-logo-image'}>
                                                <img src={CabanaLogo} alt={'logo-cabana'} className={'logo-image'}/>
                                            </Box>
                                            <Box className={'container-gifter-information-and-message'}>
                                                <Box className={'container-quantity-and-message'}>
                                                    <Typography className={'message'}>
                                                        {order.message_body}
                                                    </Typography>
                                                </Box>
                                                <Box className={'gifter-information'}>
                                                    <Typography className={'gifter-fullname'}>
                                                        {order.gifter.name} {order.gifter.surname} - {product.product_order_quantity} Qty
                                                    </Typography>
                                                    <Typography className={'gifter-email'}>
                                                        {order.gifter.email}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    )
                                }
                            }
                        }
                    })}
                </Box>
            </Box>
        </SwipeableDrawer>
    );
};

export default MessageDrawer;
